import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { useAPI } from '@providers/useAPI';
import { SupportService } from 'app/API';
import PositiveIcon from 'app/components/icons/Positive.svg';
import { useState } from 'react';
import { ContactInfo } from './ContactInfo';
import { ContactSalesForm } from './ContactSalesForm';

import { Content } from './styles/Content';
import { ToastContainer } from './styles/ToastContainer';
import { TopSpinner } from './styles/TopSpinner';

type TProps = {
  onCancel: () => void;
};

export const initialState = {
  loading: false,
  success: false,
  name: '',
  email: '',
  firm: '',
  phone: '',
  location: '',
  numOfReporters: '',
  numOfTranscriptionists: '',
  additional: '',
};

export const ContactSales = ({ onCancel }: TProps) => {
  const { call } = useAPI();
  const [formState, setFormState] = useState<typeof initialState>(initialState);
  const isButtonDisabled = !formState.firm || !formState.name || !formState.email || !formState.phone;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormState({ ...formState, loading: true });
    await call(
      SupportService.sendSalesEmail({
        requestBody: {
          fullname: formState.name,
          email: formState.email,
          agency: formState.firm,
          phone: formState.phone,
          state: formState.location,
          reporters: formState.numOfReporters,
          transcriptionists: formState.numOfTranscriptionists,
          additional: formState.additional,
        },
      }),
    );
    setFormState({ ...formState, loading: false, success: true });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  const updateForm = (name: string, value: string) => {
    setFormState({ ...formState, [name]: value });
  };

  if (formState.success) {
    return (
      <ToastContainer>
        <PositiveIcon className="iconToast" />
        <p className="descriptionToast">
          Thank you for the message!
          <br /> We will contact you soon
        </p>
      </ToastContainer>
    );
  }

  return (
    <ModalWrapper width="702px">
      {formState.loading && <TopSpinner overlay={true} />}
      <ModalTitle>Contact Our Sales Team</ModalTitle>
      <Content>
        <p className="description">
          Do you have questions regarding AutoScript services, products or anything else? <br /> Send us a note and our
          sales team will get back to you as soon as possible
        </p>
        <form onSubmit={handleSubmit}>
          <div className="content">
            <ContactSalesForm handleChange={handleChange} updateForm={updateForm} formState={formState} />
            <ContactInfo />
          </div>
          <div className="buttonContainer">
            <OutlinedButton type="button" onClick={onCancel}>
              Cancel
            </OutlinedButton>
            <Button type="submit" disabled={isButtonDisabled}>
              Submit
            </Button>
          </div>
        </form>
      </Content>
    </ModalWrapper>
  );
};
